module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box citic-box"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('div', {
    staticClass: "publish-news-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleEdit()
      }
    }
  }, [_vm._v("发布文档")])], 1), _vm._v(" "), _c('div', [_c('el-input', {
    staticClass: "search",
    attrs: {
      "placeholder": "按文档标题搜索",
      "type": "text",
      "width": "10%"
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "keywords"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "btn-search",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn-search",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "文档列表",
      "name": "document"
    }
  }, [_c('document', {
    attrs: {
      "tableType": _vm.tableType,
      "tableData": _vm.fileList,
      "tableLabel": _vm.tableLabel,
      "tableImg": _vm.tableImg
    },
    on: {
      "edit": _vm.handleEdit,
      "delete": _vm.handleDelete
    }
  }), _vm._v(" "), _c('Pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "currentChange": _vm.handlePageChange
    }
  })], 1)], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-3748cb40!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/document/document.vue
// module id = 450
// module chunks = 11